import axios from 'axios';
import { GOOGLE_KEY } from 'utils/constants';
import setConnector from 'utils/hidden';
import { isObject, css } from 'utils/helper';
import { apiMap } from 'api/apiMap';

interface ISendForm {
  formData: any;
  platform: string;
}

const sendForm = async ({ formData, platform }: ISendForm) => {
  let tokenRes: any;

  await grecaptcha.execute(GOOGLE_KEY, { action: 'submit' }).then((token: any) => (tokenRes = token));

  const newFormData = {
    ...formData,
    phone: formData.number.iso + formData.number.phone,
    platform,
    'g-recaptcha-response': tokenRes,
    ...setConnector(),
  };

  const formDataRes = new FormData();
  Object.entries(newFormData).map(([key, value]: any) => !isObject(value) && formDataRes.append(key, value));

  await axios({
    method: 'POST',
    url: apiMap.contact,
    data: formDataRes,
  }).then(() => css(document.body, { overflow: 'hidden' }));
};

export default sendForm;
